<template>
    <occupants-find
        v-if="use_uuid"
        v-slot="{
            data: occupant,
            is_loading
        }"
        :params="{
            occupant: uuid
        }"
        @success="found"
        @error="use_uuid = false"
    >
        <div
            :class="{
                'opacity-50': is_loading
            }"
            class="input is-disabled"
        >
            {{ is_loading ? 'Loading...' : occupant.name }}
        </div>
    </occupants-find>

    <algolia-get
        v-else
        index="occupants"
        :get-on-created="false"
        v-slot="{
            data,
            clear,
            filterByQuery,
            get
        }"
    >
        <with-variables
            :variables="{
                search: (query) => {
                    clear()
                    filterByQuery(query)
                    get()
                }
            }"
            v-slot="{
                search
            }"
        >
            <input-select
                :value="value"
                :sid="sid"
                :name="name"
                :disabled="disabled"
                :options="transform(data)"
                :can-search="true"
                placeholder="Select tenant..."
                @input="$emit('input', arguments[0])"
                @search="search"
                @open="search"
            />
        </with-variables>
    </algolia-get>
</template>

<script>
    import _ from 'lodash'
    import AlgoliaGet from './algolia-get'
    import OccupantsFind from './occupants-find'

    export default {
        components: {
            AlgoliaGet,
            OccupantsFind
        },
        props: {
            value: {
                validator: value => true,
                required: true
            },
            uuid: {
                type: String,
                default: null
            },
            sid: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                use_uuid: !!this.uuid
            }
        },
        methods: {
            transform (results) {
                return _.map(results, result => {
                    return {
                        value: {
                            object: result.object,
                            uuid: result.uuid
                        },
                        label: result.name
                    }
                })
            },
            found ({ data: occupant }) {
                this.$emit('input', {
                    object: occupant.object,
                    uuid: occupant.uuid
                })
            }
        }
    }
</script>
